
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 112.196 112.196"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"56.098","cy":"56.098","r":"56.098","fill":"#4d76a1"}}),_c('path',{attrs:{"d":"M53.979 80.702h4.403s1.33-.146 2.009-.878c.625-.672.605-1.934.605-1.934s-.086-5.908 2.656-6.778c2.703-.857 6.174 5.71 9.853 8.235 2.782 1.911 4.896 1.492 4.896 1.492l9.837-.137s5.146-.317 2.706-4.363c-.2-.331-1.421-2.993-7.314-8.463-6.168-5.725-5.342-4.799 2.088-14.702 4.525-6.031 6.334-9.713 5.769-11.29-.539-1.502-3.867-1.105-3.867-1.105l-11.076.069s-.821-.112-1.43.252c-.595.357-.978 1.189-.978 1.189s-1.753 4.667-4.091 8.636c-4.932 8.375-6.904 8.817-7.71 8.297-1.875-1.212-1.407-4.869-1.407-7.467 0-8.116 1.231-11.5-2.397-12.376-1.204-.291-2.09-.483-5.169-.514-3.952-.041-7.297.012-9.191.94-1.26.617-2.232 1.992-1.64 2.071.732.098 2.39.447 3.269 1.644 1.135 1.544 1.095 5.012 1.095 5.012s.652 9.554-1.523 10.741c-1.493.814-3.541-.848-7.938-8.446-2.253-3.892-3.954-8.194-3.954-8.194s-.328-.804-.913-1.234c-.71-.521-1.702-.687-1.702-.687l-10.525.069s-1.58.044-2.16.731c-.516.611-.041 1.875-.041 1.875s8.24 19.278 17.57 28.993c8.555 8.907 18.27 8.322 18.27 8.322z","fill-rule":"evenodd","clip-rule":"evenodd","fill":"#fff"}})])
          )
        }
      }
    